import { ColorValue } from "react-native/Libraries/StyleSheet/StyleSheet";
import { ImageSourcePropType } from "react-native/Libraries/Image/Image";
import { Image, Pressable, StyleSheet, Text, TouchableOpacity, View, ViewStyle } from "react-native";
import { color_333333, white } from "../../assets/style/colors";
import ArrawIcon from '../../assets/svg/icon_right_arrow.svg'
interface Setting {
    name: string,
    iconBackground: ColorValue,
    icon: React.ReactNode,
    style?: ViewStyle | ViewStyle[]
    onClick?: () => void
}

export const UserSetting = (props: Setting) => {
    // 如果传入了自定义样式，优先使用自定义样式，只从默认样式中继承必要的属性（如 flexDirection, alignItems）
    const baseStyle = props.style ? {
        flexDirection: 'row' as const,
        alignItems: 'center' as const,
    } : styles.settingContainer;
    const finalStyle = props.style ? [baseStyle, props.style] : styles.settingContainer;
    
    return (
        <Pressable style={finalStyle} onPress={props.onClick}>
            {/* <Image source={props.icon} style={styles.settingImage} /> */}
            {props.icon ? props.icon : null}
            <Text style={styles.settingText}>{props.name}</Text>
            {/* <ArrawIcon width={20} height={20}
                style={styles.settingRightImage} /> */}
        </Pressable>
    )
}


const styles = StyleSheet.create({
    settingContainer: {
        flexDirection: 'row', // 设置为纵向布局
        backgroundColor: white,
        alignItems: "center",
        paddingHorizontal: 16,
        marginHorizontal: 17,
        marginTop: 10,
        borderRadius: 12,
        height: 60
    },
    settingView: {
        width: 40,
        height: 40,
        padding: 16,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 100
    },
    settingImage: {
        width: 30,
        height: 30,
        objectFit: 'contain'
    },
    settingRightImage: {
        position: 'absolute',
        end: 16,
    },
    settingText: {
        fontSize: 14,
        color: color_333333,
        fontWeight: '500',
        fontFamily: '',
        marginStart: 12
    }
})
